/**
 * TipTap Mark extension for highlighting sensitive data
 */

import { Mark } from '@tiptap/core';

export const SensitiveDataMark = Mark.create({
  name: 'sensitiveData',

  // With inclusive: false, the cursor at boundaries doesn't have the mark active
  // This allows clicking after the mark to place cursor without the mark being active
  // exitable: true allows the cursor to exit the mark
  inclusive: false,
  exitable: true,

  addAttributes() {
    return {
      dataType: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-sensitive-type'),
        renderHTML: (attributes) => {
          if (!attributes.dataType) {
            return {};
          }
          return {
            'data-sensitive-type': attributes.dataType,
            class: 'sensitive-data-highlight',
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-sensitive-type]',
        getAttrs: (element) => {
          if (typeof element === 'string') return false;
          return {
            dataType: (element as HTMLElement).getAttribute('data-sensitive-type'),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes, mark }) {
    return [
      'span',
      {
        ...HTMLAttributes,
        class: 'sensitive-data-highlight',
        'data-sensitive-type': mark.attrs.dataType,
      },
      0,
    ];
  },
});

